"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const FormLayout_1 = tslib_1.__importStar(require("../../../components/FormLayout"));
const CheckBox_1 = require("../../../components/CheckBox");
const HelpBlock_1 = tslib_1.__importDefault(require("../../../components/HelpBlock"));
const rebass_1 = require("rebass");
const GridOptionsForm = (props) => {
    var _a;
    let { gridOptions } = props;
    return (React.createElement(rebass_1.Box, { p: 2 },
        React.createElement(HelpBlock_1.default, null, "Grid Options"),
        React.createElement(FormLayout_1.default, { margin: 2, columns: [{ name: 'children' }, { name: 'label', style: { textAlign: 'start' } }] },
            React.createElement(FormLayout_1.FormRow, { label: "Enable Range Selection" },
                React.createElement(CheckBox_1.CheckBox, { checked: gridOptions.enableRangeSelection, onChange: (enableRangeSelection) => {
                        gridOptions = Object.assign(Object.assign({}, gridOptions), { enableRangeSelection: enableRangeSelection });
                        props.onChangedGridOptions(gridOptions);
                    } })),
            React.createElement(FormLayout_1.FormRow, { label: "Show Filter Bar" },
                React.createElement(CheckBox_1.CheckBox, { checked: (_a = gridOptions.defaultColDef) === null || _a === void 0 ? void 0 : _a.floatingFilter, onChange: (floatingFilter) => {
                        gridOptions = Object.assign(Object.assign({}, gridOptions), { defaultColDef: {
                                floatingFilter,
                            } });
                        props.onChangedGridOptions(gridOptions);
                    } })),
            React.createElement(FormLayout_1.FormRow, { label: "Suppress Column Virtualisation" },
                React.createElement(CheckBox_1.CheckBox, { checked: gridOptions.suppressColumnVirtualisation, onChange: (suppressColumnVirtualisation) => {
                        gridOptions = Object.assign(Object.assign({}, gridOptions), { suppressColumnVirtualisation: suppressColumnVirtualisation });
                        props.onChangedGridOptions(gridOptions);
                    } })),
            React.createElement(FormLayout_1.FormRow, { label: "Show Column Menu Button" },
                React.createElement(CheckBox_1.CheckBox, { checked: gridOptions.suppressMenuHide, onChange: (suppressMenuHide) => {
                        gridOptions = Object.assign(Object.assign({}, gridOptions), { suppressMenuHide: suppressMenuHide });
                        props.onChangedGridOptions(gridOptions);
                    } })))));
};
exports.default = GridOptionsForm;
